export default __webpack_public_path__ + "3a239faa0b4a96bbbe632021c78226d3.png";